import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ allowedRoles = [] }) => {
  const { authUser, loading } = useAuth();

  if (loading) {
    return (
      <div className='d-flex flex-column justify-content-center align-items-center vh-100 text-muted'>
        <div
          className='spinner-border'
          role='status'
          style={{ width: '2rem', height: '2rem' }}
        />
        <small className='mt-2'>Checking session...</small>
      </div>
    );
  }

  if (!authUser) {
    // Tentukan redirect login berdasarkan allowedRoles
    if (allowedRoles.includes('Admin')) {
      return (
        <Navigate
          to='/admin/login'
          replace
        />
      );
    } else if (
      allowedRoles.includes('Mahasiswa') ||
      allowedRoles.includes('Mentor') ||
      allowedRoles.includes('DPL')
    ) {
      return (
        <Navigate
          to='/app/login'
          replace
        />
      );
    } else {
      return (
        <Navigate
          to='/app/login'
          replace
        />
      ); // default fallback
    }
  }

  const role = authUser?.activeSession?.roleCode;
  const isAllowed =
    allowedRoles.length === 0 ||
    allowedRoles.some((allowedRole) => {
      if (allowedRole === 'Admin') return role === 'ADMIN';
      if (allowedRole === 'Mahasiswa') return role === 'STUDENT';
      if (allowedRole === 'Mentor') return role === 'MENTOR';
      if (allowedRole === 'DPL') return role === 'DPL';
      if (allowedRole.toLowerCase() === 'bumdes') {
        return role?.toLowerCase()?.includes('bumdes');
      }
      return allowedRole === role;
    });

  if (!isAllowed) {
    return (
      <Navigate
        to='/'
        replace
      />
    ); // forbidden akses
  }

  const batchId = authUser?.activeSession?.batchId;

  return <Outlet key={batchId} />;
};

export default ProtectedRoute;
